import { configureStore } from "@reduxjs/toolkit";
import profileReducer from "../slices/profileSlice";
import providerReducer from "../slices/providerSlice";
import consumerReducer from "../slices/consumerSlice";

const store = configureStore({
  reducer: {
    profile: profileReducer,
    provider: providerReducer,
    consumer: consumerReducer,
  },
});

export default store;
